import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _asyncToGenerator from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.to-string.js";

/**
 * @func 异步请求的二次封装
 * @func API下发
 * @func 取消多余请求
 * @func HTTP错误统一处理
 * @Author zhangfs
 * @date 2022/04/22
 */
import axios from 'axios';

var getUrlKey = function getUrlKey(config) {
  return "IDM_PC_".concat(config.url);
};

var cancelToken = {}; // 被取消的请求池

var CancelToken = axios.CancelToken;
/**
 * @func 取消多余请求-统一处理
 * @desc type 操作类别
 * @desc config 当前请求的配置
 */

var cancelThis = function cancelThis(type, config) {
  var key = getUrlKey(config);

  if (type === 'check') {
    if (cancelToken[key]) {
      cancelToken[key]();
    } else {
      config.cancelToken = new CancelToken(function (c) {
        cancelToken[key] = c;
      });
    }
  } else if (type === 'remove') {
    delete cancelToken[key];
  }
};

var cancelTokenWhiteList = [];
/**
 * @func axios二次封装为service
 */

var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true,
  // 跨域携带 cookie
  timeout: 15000
}); // request interceptor

service.interceptors.request.use(function (config) {
  if (cancelTokenWhiteList.indexOf(config.url) !== -1) {
    cancelThis('check', config);
  }

  config.crossDomain = true;
  config.headers.common = {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-ER-System-Info': 'default',
    'Accept-Language': 'zh-CN'
  };
  return config;
}, function (err) {
  console.log('request interceptor err:', err);
  return Promise.reject(err);
}); // response interceptor

service.interceptors.response.use( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
    var result, code, message;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cancelThis('remove', response.config);
            result = response.data || {};
            code = result.code, message = result.message;

            if (!(code === '9999' || code === '-1')) {
              _context.next = 9;
              break;
            }

            _Message.closeAll();

            _Message.error(message || '服务器异常，请稍后重试或联系我们');

            return _context.abrupt("return", Promise.reject(new Error(message || 'Error')));

          case 9:
            return _context.abrupt("return", result);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), // http request err
function (err) {
  console.log('response interceptor error: ', err);
  var res = err.response; // 请求执行成功，属Http Code错误

  if (res) {
    var _ref2 = JSON.parse(JSON.stringify(res)) || {},
        status = _ref2.status,
        data = _ref2.data;

    if (Number(status) === 500) {
      _Message.error(data.message || '服务器异常，请您稍后重试或联系我们');
    } else {
      handleHttpCodeError(Number(status));
    }
  } else {
    var ErrStr = err.toString() || '';

    if (ErrStr.toString().indexOf('Cancel') !== -1) {
      // 请求被主动取消,忽略
      return;
    } else {
      // 请求执行失败，断网/超时
      handleNotExceptError(ErrStr);
    }
  }
});
/**
 * @func 通用的HttpCode异常处理
 * @param {Number} code http异常码
 */

function handleHttpCodeError(code) {
  var HttpError = {
    400: '请求错误',
    403: '拒绝访问',
    404: '请求地址错误',
    408: '请求超时',
    500: '服务器开个小差，请稍后再试',
    501: '服务器开个小差，请稍后再试',
    502: '服务器开个小差，请稍后再试',
    503: '服务器开个小差，请稍后再试',
    504: '服务器开个小差，请稍后再试',
    505: 'HTTP版本不受支持'
  };

  _Message.error(HttpError[code]);
}
/**
 * @func 请求执行失败，断网/超时/未知错误
 * @param {Object} err 错误信息载体
 */


function handleNotExceptError(ErrStr) {
  _Message.closeAll();

  if (ErrStr.indexOf('Request failed') !== -1) {
    _Message.error('当前网络不可用，请检查网络设置');
  } else if (ErrStr.indexOf('timeout') !== -1) {
    _Message.error('您当前网络较差，请切换网络或稍后重试');
  } else {
    _Message.error('发生未知错误，请稍后重试');
  }
}

export default service;